import './style.scss';
import DateRangePicker from './daterangepicker.js';

export default DateRangePicker;